<template>
  <div id="user-table" v-if="$auth.check(['Pull'])">
    <div v-if="loading" class="overlay">
      <div><img class="spinner" src="loading.gif" alt="Loading data..." /></div>
    </div>
    <h1 style="text-align: left; text-transform: uppercase">
      Histórico de resgates
    </h1>
    <div class="">
      <div v-if="!filteredTeam || filteredTeam.length === 0">
        Sem histórico de resgates
      </div>
      <div v-else>
        <div class="card-content">
          <div
            v-for="(dsr, index) in filteredTeam"
            :key="dsr.id"
            class="card"
            style="
              border: 1px solid #e7d9d0;
              border-radius: 8px;
              padding: 16px;
              margin-bottom: 16px;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            "
          >
            <!-- Nome and Status on the same line -->
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 16px;
              "
            >
              <!-- Nome -->
              <div>
                <div style="font-size: 18px; color: #666">Nome</div>
                <strong style="font-size: 24px; color: #333">{{
                  dsr.name
                }}</strong>
              </div>

              <!-- Status -->
              <div
                style="
                  text-align: right;
                  font-size: 14px;
                  font-weight: bold;
                  padding: 8px;
                  border-radius: 4px;
                "
                :style="{
                  backgroundColor: dsr.status_id === 1 ? '#d4edda' : '#f8d7da',
                  color: dsr.status_id === 1 ? '#155724' : '#721c24',
                }"
              >
                {{ dsr.status_id === 1 ? "Aprovado" : "Rejeitado" }}
              </div>
            </div>

            <!-- Pontos UFS -->
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-bottom: 8px;
              "
            >
              <div style="font-size: 18px; color: #333">Pontos UFS</div>
              <div style="font-size: 18px; color: #333; text-align: right">
                {{ Math.round(dsr.ufs_points) }}
              </div>
            </div>

            <!-- Pontos OLA -->
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-bottom: 8px;
              "
            >
              <div style="font-size: 18px; color: #333">Pontos OLA</div>
              <div style="font-size: 18px; color: #333; text-align: right">
                {{ Math.round(dsr.ola_points) }}
              </div>
            </div>

            <!-- Total -->
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-bottom: 16px;
              "
            >
              <div style="font-size: 18px; color: #666">Total</div>
              <div style="font-size: 18px; color: #f48c4f; text-align: right">
                {{ Math.round(dsr.total) }}
              </div>
            </div>

            <!-- "Ver recibo" Button -->
            <div style="margin-bottom: 16px">
              <button
                @click="openModal(dsr.image)"
                style="
                  background-color: #f48c4f;
                  font-size: 14px;
                  color: white;
                  border: none;
                  width: 100%;
                  padding: 12px;
                  border-radius: 8px;
                  cursor: pointer;
                  text-transform: uppercase;
                "
              >
                Ver recibo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rejection Modal -->
    <div
      id="rejection-modal"
      class="modal-overlay"
      v-if="isModalOpen"
      @click="closeRejectionModal"
    >
      <div class="modal-content" @click.stop>
        <h2 style="text-transform: uppercase; margin-bottom: 30px">
          Motivo de Rejeição
        </h2>
        <form @submit.prevent="submitRejection">
          <div class="form-group">
            <textarea
              v-model="message"
              placeholder="Indique o motivo de rejeição"
              class="form-control form-name"
            ></textarea>
          </div>
          <div class="form-group">
            <div class="container">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-secondary format"
                    @click="closeRejectionModal"
                  >
                    CANCELAR
                  </button>
                </div>
                <div class="col-6 text-right">
                  <button type="submit" class="btn btn-primary">ENVIAR</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Image Modal -->
    <div v-if="modalOpen" class="modal modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <img
          v-if="!isPdf"
          :src="currentImage"
          alt="Recibo"
          style="max-width: 100%; max-height: 80vh"
        />

        <!-- PDF -->
        <iframe
          v-else
          :src="currentImage"
          style="width: 100%; height: 80vh"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
  <div v-else>
    <p>Access Denied: You are not authorized to view this page.</p>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loading: null,
      team: [],
      modalOpen: false,
      currentImage: null,
      action: null,
      isModalOpen: false,
      message: "",
      rejectionId: null,
    };
  },

  computed: {
    filteredTeam() {
      // Return only entries with status_id 1 or 2
      return this.team.filter(
        (dsr) => dsr.status_id === 1 || dsr.status_id === 2,
      );
    },

    isPdf() {
      if (!this.currentImage) return false;
      return this.currentImage.toLowerCase().endsWith(".pdf");
    },
  },

  async mounted() {
    this.fetchName();
    this.fetchTeam();
  },

  methods: {
    async fetchTeam() {
      this.loading = true;
      this.error = null;

      try {
        const response = await axios.get(`app/getTeamPull`);

        if (response.status === 200 && response.data) {
          this.team = response.data;
        } else {
          console.error("Failed to fetch data:", response);
        }
      } catch (error) {
        console.error("Error fetching team data:", error);
        if (error.response) {
          console.error("Error response:", error.response.data);
        }
      } finally {
        this.loading = false; // Always reset loading
      }
    },

    fetchName() {
      this.loading = true;
      this.error = null;
      this.user = null;

      this.axios
        .get("app/getInfo")
        .then((response) => {
          // Assuming response.data contains the object with the name field
          this.user = response.data.name;
          this.ufs_code = response.data.ufs_code;
          this.loading = false;
        })
        .catch((error) => {
          this.error = error.message;
          this.loading = false;
        });
    },

    openModal(imageUrl) {
      this.currentImage = imageUrl;
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
      this.currentImage = null;
    },
  },
};
</script>

<style>
.spinner {
  width: 80px;
  height: 80px;
  text-align: center;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 50% opacity grey */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's on top of everything */
}

/* Estilos Gerais */
#user-table {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  margin: 20px;
}

.card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
}

input[type="checkbox"] {
  transform: scale(1.2);
  cursor: pointer;
}

.btn-submit {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.btn-submit:hover {
  background-color: #0056b3;
}

.table th {
  background-color: #f48c4f;
  color: white;
  vertical-align: middle;
}

/* Responsividade */
.table-responsive {
  overflow-x: auto;
}

.comprovativo-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  align-items: center;
}

/* Botões */
.btn-accept,
.btn-reject {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  margin: 0 5px;
}

.btn-accept {
  color: #00c939;
}

.btn-reject {
  color: red;
}

.btn-accept:hover {
  color: #008f2c;
}

.btn-reject:hover {
  color: #cc0000;
}

/* Ajustes para telas pequenas */
@media (max-width: 768px) {
  .table th,
  .table td {
    font-size: 12px;
    padding: 5px;
    vertical-align: middle !important;
  }

  .comprovativo-img {
    width: 40px;
    height: 40px;
  }

  .btn-accept,
  .btn-reject {
    font-size: 14px;
  }
}

.format {
  background-color: none;
  border: none;
  color: #ff5a00;
}

@media (max-width: 480px) {
  h1 {
    font-size: 18px;
    text-align: center;
  }

  .card {
    padding: 10px;
  }

  .table th,
  .table td {
    font-size: 10px;
    padding: 3px;
    text-align-last: center;
    vertical-align: middle;
  }

  .comprovativo-img {
    width: 30px;
    height: 30px;
  }

  .btn-accept,
  .btn-reject {
    font-size: 12px;
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 90%;
  max-height: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
}

.modal-content img {
  width: 100%;
  height: auto;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content .close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

#form-contact .modal-body {
  padding: 0 0;
  padding-top: 20px;
}

#form-contact .border-box {
  border: 1px solid #e4e7ea;
  border-radius: 5px;
  padding: 10px;
  /*background-color: #f8f9fa;*/
  margin-bottom: 20px;
  font-size: 16px;
}

#form-contact .form-group {
  margin-bottom: 15px;
}

#form-contact .form-name {
  width: 100%;
  /* padding: 10px; */
  font-size: 14px;
  min-height: 5vh;
  max-height: 5vh;
}

.close:hover {
  color: black;
}

.main .container-fluid {
  padding: 50px 5px !important;
}

.btn-view-image {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

#download .btn-primary {
  background-color: #fff;
  color: #c26e00;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 60%;
  margin-top: 30px;
  text-transform: uppercase;
  margin-left: 20%;
  margin-right: 20%;
  margin-bottom: 30px;
}

#rejection-modal .btn-primary {
  background-color: #f48c4f;
  color: #fff;
  border: none;
}

#rejection-modal .format {
  background-color: #fff;
}

#form-contact .close-btn {
  color: #c26e00;
  border: none;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  background: none;
  cursor: pointer;
}

.btn-view-image:hover {
  background-color: #0056b3;
}
</style>
